import { FormationDetailProps } from "@/types/formation";

export const atmosphereExplosiveFormation: FormationDetailProps = {
  id: "19",
  title: "Formation Atmosphère Explosive - Niveau 0",
  description: "Cette formation permet d'identifier les conditions de survenue d'une Atmosphère Explosive et de savoir les risques associés afin d'intervenir en sécurité dans des zones d'exploitation présentant un risque d'explosion.",
  duration: "4 heures (1/2 journée)",
  category: "Risques Spécifiques",
  imageSrc: "/images/formations/Atex.webp",
  slug: "atmosphere-explosive-niveau-0",
  reference: "F-Atex niveau 0",
  price: "Sur devis – nous contacter",
  targetAudience: "L'ensemble des salariés d'une entreprise conformément au code du travail",
  prerequisites: "Aucun prérequis n'est nécessaire pour suivre la formation de travail en sécurité en zone ATEX-NIVEAU 0",
  objectives: [
    "Identifier les conditions de survenue d'une Atmosphère Explosive et de définir les risques associés",
    "Adapter ses procédures préalables à toute intervention",
    "Être capable d'identifier les zones d'intervention",
    "Être capable de travailler en sécurité dans des zones présentant un risque d'explosion"
  ],
  program: [
    {
      title: "Partie théorique 60%",
      items: [
        "Définition d'une zone ATEX",
        "Les risques liés aux interventions en ce milieu",
        "Les obligations de résultat",
        "La co-activité/modes et interactions/indication des zones",
        "La réglementation",
        "Règles d'intervention en ATEX",
        "L'organisation du travail (autorisation de travail, permis feu)",
        "Les outils adaptés des ATEX",
        "La formation d'une ATEX",
        "La combustion",
        "La substitution",
        "Les limites d'explosivité",
        "Les substances",
        "Classification des ATEX",
        "Le marquage du matériel",
        "Les différents modes de protection",
        "Les interactions/interférences entre installations incompatibles"
      ]
    },
    {
      title: "Partie pratique 40%",
      items: [
        "Exercices",
        "Balisage des zones et du matériel associé",
        "Identification des risques à disposition",
        "Analyse des risques",
        "Définition du matériel adapté selon différents zonages"
      ]
    }
  ],
  numberOfParticipants: "10 Participants",
  pedagogicalMethods: [
    "Exposés interactifs, démonstrations par le formateur, exercice sur site"
  ],
  evaluationMethods: [
    "En 1er jour de la formation : Questionnaire des besoins et positionnement de l'apprenant",
    "Pendant la formation : Atelier pratique en situation réelle + exercices applicatifs",
    "Fin de formation : QCM pour évaluation des acquis + évaluation de satisfaction à chaud",
    "Après la formation : Évaluation à froid pour vérifier les compétences de l'apprenant"
  ],
  certification: "Cette action de formation sera validée par un certificat de réalisation nominative, après la réalisation du QCM final par évaluation des acquis.",
  registrationProcess: [
    "Inscription par téléphone, par mail ou par le site internet",
    "Délai d'accès selon un agenda interne de session de l'entreprise",
    "Inscription 15 jours avant le début de la formation"
  ],
  accessibilityCriteria: "Pour toute personne en situation d'handicap, Nous sommes susceptibles d'accueillir les personnes moins de nous contacter au préalable pour étudier toute situation.",
  formatterInfo: {
    name: "Sebastien Davrainville - SDPSI Formation",
    phone: "06.22.61.04.09",
    email: "sdpsiformation@orange.fr",
    website: "www.sdpsi-formations.fr"
  }
};
